<template>
    <div style="max-width: 100%;">
        <div style="max-width: 100%;">
            <div style="max-width: 100%;">
                <v-row>
                    <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 2" :class="{
                        'd-flex justify-space-around align-center text-center': true,
                        'flex-column': !$vuetify.breakpoint.mobile,
                        'flex-row': $vuetify.breakpoint.mobile
                    }"  :style="{ padding: $vuetify.breakpoint.mobile ? '0' : '12px' }">
                        <span class="font-weight-black text-h5">
                            Embarcaciones:
                        </span>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="mx-2" fab dark small color="#05435B" v-bind="attrs" v-on="on"
                                    @click="selectedEmbarcaciones = []">
                                    <v-icon dark>mdi-filter-remove</v-icon>
                                </v-btn>
                            </template>
                            <span>Limpiar Filtros</span>
                        </v-tooltip>
                    </v-col>

                    <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 10" :style="{ padding: $vuetify.breakpoint.mobile ? '0' : '12px' }">
                        <!-- Carrusel en dispositivos móviles -->
                        <v-slide-group v-if="$vuetify.breakpoint.mobile" v-model="selectedEmbarcaciones" class="pa-2"
                            multiple show-arrows style="max-width: 100vw; overflow: hidden;">
                            <v-slide-item v-for="emb in embarcaciones" :key="emb" v-slot="{ active, toggle }"
                                :value="emb">
                                <v-card class="ma-1 px-3 d-flex align-center justify-center"
                                    :color="active ? '#05435B' : 'grey lighten-2'" height="30" width="auto"
                                    min-width="100" max-width="150" @click="toggle">
                                    <span class="text-center font-weight-bold text-body-2"
                                        :style="{ color: active ? 'white' : 'black' }">
                                        {{ emb }}
                                    </span>
                                </v-card>
                            </v-slide-item>
                        </v-slide-group>


                        <!-- Botones en Desktop -->
                        <v-btn-toggle v-else v-model="selectedEmbarcaciones" color="#05435B" multiple
                            class="d-flex flex-wrap justify-center" style="gap: 5px;">
                            <v-btn style="padding:5px; font-size: 12px; font-weight: 700; height: 30px;"
                                v-for="emb in embarcaciones" :key="emb" :value="emb">
                                {{ emb }}
                            </v-btn>
                        </v-btn-toggle>
                    </v-col>
                </v-row>

            </div>

        </div>
        <v-divider style="margin-bottom: 10px; margin-top: 10px; max-width: 100%;"></v-divider>
        <div class="d-flex flex-column mb-4" style="max-width: 100%;">
            <v-row>
                <v-col cols="12" style="max-width: 100vw; overflow: hidden;">
                    <v-data-table v-if="!$vuetify.breakpoint.mobile" :headers="headers" :items="filteredItems"
                        class="elevation-1">
                        <template v-slot:item.fechaUltimoMuestreo="{ item }">
                            <span>
                                {{ item.fechaUltimoMuestreo == "2000-01-01" ? '' : formatDate(item.fechaUltimoMuestreo)
                                }}
                            </span>
                        </template>
                        <template v-slot:item.estadoReporte="{ item }">
                            <div class="text-center" v-if="item.fechaUltimoMuestreo != '2000-01-01'">
                                <v-chip :color="getConditionColor(item.estadoReporte)" dark>
                                    {{ item.estadoReporte }}
                                </v-chip>
                            </div>
                        </template>
                        <template v-slot:item.proximoMuestreo="{ item }">
                            <span :style="getDateStyle(item.proximoMuestreo)">
                                {{ item.proximoMuestreo == "2000-01-01" ? "" : formatDate(item.proximoMuestreo) }}
                            </span>
                        </template>
                        <template v-slot:item.url="{ item }">
                            <v-tooltip v-if="item.url != ''" bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon color="red" v-bind="attrs" v-on="on" @click="descargarArchivo(item)">
                                        <v-icon>mdi-file-pdf-box</v-icon>
                                    </v-btn>
                                </template>
                                <span>Descargar Resultado</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>

                    <v-data-table v-else :headers="headersMobile" :items="filteredItems" :single-expand="singleExpand"
                        :mobile-breakpoint="0" :expanded.sync="expanded" item-key="uniqueKey" show-expand
                        class="elevation-1">
                        <template v-slot:item.embarcacion="{ item }">
                            <span>
                                {{ item.embarcacion }} - {{ item.componente }}
                            </span>
                        </template>
                        <template v-slot:item.proximoMuestreo="{ item }">
                            <span :style="getDateStyle(item.proximoMuestreo)">
                                {{ item.proximoMuestreo == "2000-01-01" ? "" : formatDate(item.proximoMuestreo) }}
                            </span>
                        </template>
                        <template v-slot:item.url="{ item }">
                            <v-tooltip v-if="item.url != ''" bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon color="red" v-bind="attrs" v-on="on" @click="descargarArchivo(item)">
                                        <v-icon>mdi-file-pdf-box</v-icon>
                                    </v-btn>
                                </template>
                                <span>Descargar Resultado</span>
                            </v-tooltip>
                        </template>
                        <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length">
                                <br>
                                <span style="font-weight: 600;">Marca:</span> {{ item.marca }} <br>
                                <span style="font-weight: 600;">Modelo:</span> {{ item.modelo }} <br>
                                <span style="font-weight: 600;">Capacidad:</span> {{ item.capacidad }} <br>
                                <span style="font-weight: 600;">Lubricante:</span> {{ item.lubricante }} <br>
                                <span style="font-weight: 600;">Frecuencia de cambio de aceite:</span> {{
                        item.frecuenciaCambioAceite }} <br>
                                <span style="font-weight: 600;">Ratio de horómetro por día:</span> {{
                        item.ratioHorometroDia }} <br>
                                <span style="font-weight: 600;">Frecuencia de Muestreo:</span> {{
                        item.frecuenciaMuestreo }} <br>
                                <span style="font-weight: 600;">Fecha de último muestreo:</span> {{
                        item.fechaUltimoMuestreo }} <br>
                                <span style="font-weight: 600;">Horómetro del último muestreo:</span> {{ item.hrsEquipo
                                }} <br>
                                <span style="font-weight: 600;">Última Condición:</span> <v-chip
                                    v-if="item.fechaUltimoMuestreo != '2000-01-01'"
                                    :color="getConditionColor(item.estadoReporte)" dark>
                                    {{ item.estadoReporte }}
                                </v-chip>
                                <br>
                                <br>
                            </td>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>

        </div>
    </div>
</template>

<script>
import apiService from "@/services/apiService";
import SwalService from '@/services/swalService';
export default {
    data() {
        return {
            expanded: [],
            singleExpand: false,
            selectedEmbarcaciones: [],
            embarcaciones: [
                "ANA LUCIA", "BAMAR I", "BAMAR II", "BAMAR IV", "BAMAR VIII", "CHATA PH1", "CHATA PH5",
                "CHAVELI II", "CHIRA I", "ISABELITA", "IVANA B", "JACKELIN", "JADRANKA B", "KIARA B", "LOMAS"
            ],
            headers: [
                { text: "Embarcación", value: "embarcacion" },
                { text: "Componente", value: "componente" },
                { text: "Marca", value: "marca" },
                { text: "Modelo", value: "modelo" },
                { text: "Capacidad", value: "capacidad", sortable: false, align: "center" },
                { text: "Lubricante", value: "lubricante", sortable: false },
                { text: "Frecuencia de cambio de aceite", value: "frecuenciaCambioAceite", sortable: false, align: "center" },
                { text: "Ratio de horómetro por día", value: "ratioHorometroDia", sortable: false, align: "center" },
                { text: "Frecuencia de Muestreo", value: "frecuenciaMuestreo", sortable: false, align: "center" },
                { text: "Fecha de último muestreo", value: "fechaUltimoMuestreo", align: "center" },
                { text: "Horómetro del último muestreo", value: "hrsEquipo", sortable: false, align: "center" },
                { text: "Última Condición", value: "estadoReporte" },
                { text: "Próximo muestreo", value: "proximoMuestreo", align: "center", width: 100 },
                { text: "Resultado", value: "url", align: "center",  sortable: false, }
            ],
            headersMobile: [
                { text: "Embarcación - Componente", value: "embarcacion" },
                { text: "Próximo muestreo", value: "proximoMuestreo", align: "center" },
                { text: "Resultado", value: "url", align: "center", sortable: false,},
                { text: '', value: 'data-table-expand' },
            ],
            items: [
                { embarcacion: "ANA LUCIA", componente: "CAJA MULTIPLICADORA", marca: "ITALMECAN", modelo: "IT-3B", capacidad: "4", lubricante: "ACEITE OMALA 220", frecuenciaCambioAceite: "3000", ratioHorometroDia: "20", frecuenciaMuestreo: "500", fechaUltimoMuestreo: "", hrsEquipo: "", estadoReporte: "Alerta", proximoMuestreo: "24/02/2025", uniqueKey: "test1" },
                { embarcacion: "BAMAR I", componente: "GRUPO ELECTROGENO I", marca: "CATERPILLAR", modelo: "3304", capacidad: "8", lubricante: "ACEITE RIMULA R4 X 15W/40", frecuenciaCambioAceite: "250", ratioHorometroDia: "20", frecuenciaMuestreo: "250", fechaUltimoMuestreo: "30/01/25", hrsEquipo: "", estadoReporte: "Normal", proximoMuestreo: "24/02/2025", uniqueKey: "test2" }
            ]
        };
    },
    computed: {
        filteredItems() {
            if (this.selectedEmbarcaciones.length === 0) return this.items;
            return this.items.filter(item => this.selectedEmbarcaciones.includes(item.embarcacion));
        }
    },
    created() {
        this.getData();
    },
    methods: {
        getConditionColor(condition) {
            switch (condition) {
                case "Alerta": return "red";
                case "Precaución": return "orange";
                case "Normal": return "green";
                default: return "grey";
            }
        },
        getDateStyle(date) {
            if (!date) return ""; // Si la fecha es null o undefined, no aplica estilos

            // Convertir la fecha de "yyyy-mm-dd" a un objeto Date
            const [year, month, day] = date.split("-").map(Number);
            const fechaComparar = new Date(year, month - 1, day); // Meses en JavaScript van de 0 a 11

            // Obtener la fecha actual sin hora
            const fechaActual = new Date();
            fechaActual.setHours(0, 0, 0, 0); // Eliminar horas para comparar solo fechas

            // Comparar si la fecha es menor a hoy
            return fechaComparar < fechaActual ? "color: red; font-weight: bold;" : "";
        },

        formatDate(date) {
            if (!date) return ""; // Si la fecha es null o undefined, no mostrar nada

            // Convertir "yyyy-mm-dd" a "dd-mm-yyyy"
            const [year, month, day] = date.split("-");
            return `${day}-${month}-${year}`;
        },

        async getData() {
            SwalService.loading('Cargando..', 'Por favor espere.');
            const response = await apiService.get("/programa-trabajos/get-programa-muestreo-aceite")

            this.embarcaciones = response.data.embarcaciones;
            this.items = response.data.listaMuestreo.map(item => ({
                ...item,
                uniqueKey: `${item.embarcacion}-${item.componente}` // Concatenación de clave única
            }));
            console.log(this.items)

            SwalService.close();
            await new Promise(resolve => setTimeout(resolve, 100));
        },
        async descargarArchivo(item) {
            try {
                SwalService.loading('Descargando...', 'Por favor espere.');
                const fileName = item.embarcacion + '-' + item.componente + ".pdf";
                const body = {
                    url: item.url,
                    nameFile: fileName

                }
                await apiService.downloadFiles(`/programa-trabajos/get-resultado-pdf`, body, fileName);
                SwalService.close();
                await new Promise(resolve => setTimeout(resolve, 100));
            } catch (error) {
                console.error('Error al descargar el archivo:', error);

                SwalService.close();
                SwalService.error('No se pudo descargar el archivo. Intenta nuevamente.');
                await new Promise(resolve => setTimeout(resolve, 100));
            }
        }
    }
};
</script>

<style scoped>
/* Estilos mejorados */
.v-data-table {
    border-radius: 10px;
    overflow: hidden;
    font-size: 12px !important;
}

.v-data-table>>>thead th {
    font-size: 12px !important;
    font-weight: bold;
    text-align: center !important;
    color: white !important;
    background-color: #05435B;
}


.v-data-table>>>tbody td {
    font-size: 11px !important;
}

td {
    text-align: center !important;
    border-bottom: 1px solid #ddd;
    font-size: 12px !important;
}

.table-container {
    display: block;
}

.mobile-table {
    display: none;
}

.v-data-table>>>thead th.sortable .v-data-table-header__icon {
    color: white !important;
    font-weight: 700;
}

@media (max-width: 768px) {
    .desktop-table {
        display: none;
    }

    .mobile-table {
        display: block;
    }

    .scrollable-table {
        overflow-x: auto;
        white-space: nowrap;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    th,
    td {
        padding: 8px;
        text-align: left;
        border-bottom: 1px solid #ddd;
    }

    .sticky-right {
        position: sticky;
        right: 0;
        background: white;
        z-index: 2;
    }
}
</style>